// extracted by mini-css-extract-plugin
export default {"experiences":"Experiences_experiences__k25sQ","exp":"Experiences_exp__Ii9gc","Logos":"Experiences_Logos__DzdF9","ContainerExp":"Experiences_ContainerExp__zHaL6"};